export default {
    i18n: {
        "Battery Level": "Batareya səviyyəsi",
        "tamperAlarm": "Sökülmə siqnalı",
        "call": "Zəng etmək",
        "lock": "Qapını bağla",
        "Floor": "Mərtəbə",
        "Action": "Fəaliyyət",
        "Address": "Ünvan",
        "Owner": "Sahibi",
        "Failed": "Uğursuz",
        "Timeout": "Fasilə",
        "Response": " Cavab",
        "caller": "Zəng edən",
        "receiver": "Qəbuledici",
        "doorLogs": "Qapı Günlükləri",
        "callHistory": "Zəng Tarixi",
        "UID": "UID",
        "Call Type": "Zəng növü",
        "Code": "Kod",
        "User": "İstifadəçi",
        "Device List": "Cihaz siyahısı",
        "Model": "Model",
        "Company": "Şirkət",
        "Property Managers": "Əmlak menecerləri",
        "Current Version": "Cari Versiya",
        "indoorMonitor": " Daxili Monitor",
        "guardPhone": "Mühafizə Telefonu",
        "close": "Bağlayın",
        "Success": "Uğurlu",
        "URL": "URL",
        "Please select a device.": "Zəhmət olmasa cihaz seçin.",
        "Password is too weak.": "Parol çox zəifdir.",
        "Company is required.": "Şirkət tələb olunur.",
        "Your account is not activated, please contact your service provider.": "Hesabınız aktiv deyil, xidmət provayderinizlə əlaqə saxlayın.",
        "Face": "Üz",
        "Please set at least one access type.": "Ən azı bir giriş növü təyin edin.",
        "Please contact your service provider to activate this advanced feature.": "Bu təkmil funksiyanı aktivləşdirmək üçün xidmət təminatçınızla əlaqə saxlayın.",
        "Community name": "İcma adı",
        "Please enable PM App first.": "Zəhmət olmasa əvvəlcə PM tətbiqini aktivləşdirin.",
        "Username": "İstifadəçi adı",
        "Change Log": "Qeydi dəyişdirin",
        "Assign": "Təyin et",
        "Link Device": "Bağlantı Cihazı",
        "Accessible Floors": "Əlçatan mərtəbələr",
        "Upgrade": "Təkmilləşdirin",
        "Function": "Funksiya",
        "callDuration": "Zəng müddəti",
        "No": "Xeyr",
        "Verification Code": "Doğrulama kodu",
        "Expiration Time": "İstifadə müddəti",
        "PIN": "PIN",
        "MAC": "MAC",
        "Building": "Bina",
        "Group Call": "Qrup Zəngi",
        "Yes": "Bəli",
        "Door Release PIN": "Qapı Açma PIN kodu",
        "Email": "E-poçt",
        "Tips": "Məsləhətlər",
        "The end time cannot be earlier than the start time.": "Bitmə vaxtı başlanğıc vaxtından tez ola bilməz.",
        "Back": "Geri",
        "motionDetection": "Hərəkət  Aşkarlanması",
        "nfc": "NFC",
        "Unlimited": "Limitsiz",
        "Password Incorrect.": "Səhv Şifrə ",
        "Please try again 24 hours later.": "24 saat sonra yenidən cəhd edin.",
        "You are trying too often, please try again in 5 minutes": "Çox tez-tez cəhd edirsiniz, Zəhmət olmasa, 5 dəqiqədən sonra yenidən cəhd edin",
        "User name too long.": " İstifadəçi adı çox uzundur.",
        "This MAC address is redirected on RPS.": "Bu MAC ünvanı RPS-də yönləndirilir.",
        "No Answer": "Cavab yoxdur",
        "failedToUnlock": "Kilidi açmaq alınmadı",
        "visitor": "Ziyarətçi",
        "yesterday": "Dünən",
        "Too large data! Please first export the data before %s first,thanks.": "Çox böyük data! Zəhmət olmasa, əvvəlcə %s əvvəl datanı ixrac edin, təşəkkürlər.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Ödənilməmiş sifarişlərin olub olmadığını yoxlayın, əgər yoxdursa, xidmət təminatçınızla əlaqə saxlayın",
        "open": "Açıq",
        "The PersonalAccount is not active.": "PersonalAccount aktiv deyil.",
        "You cannot link an account that already link other accounts.": "Siz artıq digər hesabları birləşdirən hesabı əlaqələndirə bilməzsiniz.",
        "You cannot link multiple property manager accounts under the same installer account.": "Eyni quraşdırıcı hesabı altında birdən çox mülkiyyət meneceri hesabını əlaqələndirə bilməzsiniz.",
        "You cannot link to the currently logged in account.": "Hazırda daxil olmuş hesaba keçid edə bilməzsiniz.",
        "activities": "Fəaliyyətlər",
        "Obtain": "əldə edin",
        "Mobile Number doesn\'t exist.": "Mobil Nömrə mövcud deyil.",
        "File format error.": "Fayl formatı xətası.",
        "Are you sure you want to delete this device?": "Bu cihazı silmək istədiyinizə əminsiniz?",
        "confirmToDeleteIt?": "Silmək üçün təsdiq edilsin?",
        "captureLogs": "Qeydləri ələ keçirin",
        "Doors": "Qapılar",
        "All Doors": "Bütün Qapılar",
        "Lock List": "Kilid siyahısı",
        "Link Device Relay": "Cihaz Relayını əlaqələndirin",
        "Added Successfully!": "Uğurla əlavə edildi!",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Kilid bir rele ilə birləşdirildikdə, rele işə salındıqda kilid açılacaqdır.",
        "Adding...": "Əlavə edilir...",
        "Device deleted successfully": "Cihaz uğurla silindi",
        "Failed to delete device": "Cihazı silmək alınmadı",
        "auto": "Avtomatik",
        "Volume": "Səs",
        "Group": "Qrup",
        "None": "Heç biri",
        "minutes": "dəqiqələr",
        "Http": "HTTP",
        "Date Time": "Tarix Saat",
        "Card": "Kart",
        "deliverySystemVerification": "Çatdırılma sisteminin yoxlanılması",
        "name": "Ad",
        "APT": "APT",
        "Delete": "Silin",
        "Device Name": "Cihaz Adı",
        "ID": "ID",
        "Language": "Dil",
        "Name": "Ad",
        "Password": "Şifrə",
        "Time": "Vaxt",
        "unlock": "Açın",
        "Upgrading...": "Təkmilləşdirilir...",
        "amenityReservation": "Rahatlıq Rezervasyonu",
        "idAccess": "ID Girişi",
        "handset": "Dəstə",
        "RF Card": "RF Kart",
        "Fingerprint": "Barmaq izi",
        "Access Denied.": "Girişə icazə verilmədi.",
        "exitButton": "Qapı açma düyməsi",
        "date": "Tarix",
        "day": "gün",
        "Please select at least one item.": "Ən azı bir element seçin.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID yalnız rəqəm və hərflərdən ibarət ola bilər, 32 simvola qədər.",
        "The PIN is not available.": "PIN mövcud deyil.",
        "Change WiFi": "WiFi dəyişdirin",
        "Are you sure you want to cancel?": "Ləğv etmək istədiyinizə əminsiniz?",
        "Phone number": "Telefon nömrəsi",
        "Invalid {0}.": "Yanlış {0}.",
        "{0} already exists.": "{0} artıq mövcuddur.",
        "Operation failed!": "Əməliyyat uğursuz oldu!",
        "Failed to get data.": "Data əldə etmək alınmadı",
        "You do not have the necessary permissions to perform this operation.": "Bu əməliyyatı yerinə yetirmək üçün lazımi icazələrə malik deyilsiniz.",
        "You can only import one template at a time in the current site.": "Siz cari saytda eyni anda yalnız bir şablon idxal edə bilərsiniz.",
        "timezone": "saat qurşağı",
        "Delivery name": "Çatdırılma adı",
        "MAC address not in the MAC library.": "MAC ünvanı MAC kitabxanasında deyil.",
        "Please delete devices under this building.": "Bu binanın altındakı cihazları silin.",
        "The start time cannot be later than the end time.": "Başlama vaxtı bitiş vaxtından gec ola bilməz.",
        "emergency action type": "fövqəladə fəaliyyət növü",
        "Only 1000 data items can be imported at a time.": "Eyni anda yalnız 1000 məlumat elementi idxal edilə bilər.",
        "The password is too short.": "Şifrə çox qısadır.",
        "The data has been updated. Please refresh the page and try again.": "Məlumatlar yenilənib. Səhifəni yeniləyin və yenidən cəhd edin.",
        "AutoP length must be less 2048 bytes.": "AutoP uzunluğu 2048 baytdan az olmalıdır.",
        "File Check Failed": " Fayl Yoxlanılmadı",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Administrator hesabına giriş müddəti başa çatıb. Zəhmət olmasa xidmət provayderinizlə əlaqə saxlayın.",
        "iqPinVerificationFailed": "IQ PIN doğrulaması alınmadı.",
        "accountBlacklisted": "Hesab qara siyahıya salındı.",
        "outsideAuthorizedTime": "İcazə verilən vaxtdan kənar.",
        "network group": "şəbəkə qrupu",
        "Company name": "Şirkət adı",
        "Group name": "Qrup adı",
        "relay": "rele",
        "motionTime": "hərəkət vaxtı",
        "motionType": "hərəkət vaxtı",
        "postalCode": "poçt kodu",
        "floor format": "mərtəbə formatı",
        "mobilePhone": "mobil telefon",
        "time format": "vaxt formatı",
        "security relay": "təhlükəsizlik rölesi",
        "Param": "Param",
        "Offline Code": "Oflayn Kod",
        "Device Information": "Cihaz Məlumatı",
        "Add akubela Smart Locks": "Akubela Smart Kilidləri əlavə edin",
        "Module Version": "Modul versiyası",
        "Lock Body Version": "Bədən Versiyasını Kilidləyin",
        "Available Version": "Mövcud versiya",
        "Please wake up the lock screen and then upgrade.": "Zəhmət olmasa, kilid ekranını oyandırın və sonra təkmilləşdirin.",
        "This process will take some time, please be patient.": "Bu proses bir az vaxt aparacaq, səbirli olun.",
        "Please confirm that the WiFi network is functioning properly.": "Zəhmət olmasa, WiFi şəbəkəsinin düzgün işlədiyini təsdiqləyin.",
        "Please wake up the lock screen.": "Zəhmət olmasa, kilid ekranını oyandırın.",
        "This lock has already been added to another apartment.": "Bu kilid artıq başqa mənzilə əlavə olunub.",
        "This lock has already been added to the apartment.": "Bu kilid artıq mənzilə əlavə olunub.",
        "Pin Code": "Pin kodu",
        "Too many failed attempts, please try again in a few minutes.": "Həddindən artıq uğursuz cəhd, bir neçə dəqiqədən sonra yenidən cəhd edin.",
        "Login Account": "Giriş Hesabı",
        "Same account cannot login in different ins.": "Same account cannot login in different ins.",
        "Lock Name": "Kilid adı",
        "Smart Locks": "Ağıllı Kilidlər",
        "Add Smart Lock": "Smart Kilidi əlavə edin",
        "Attendance Point Name": "Davamiyyət nöqtəsinin adı",
        "The selected duration cannot be more than one year.": "Seçilmiş müddət bir ildən çox ola bilməz.",
        "The end time of the break time cannot be later than the end work time.": "Fasilə vaxtının bitmə vaxtı işin bitmə vaxtından gec ola bilməz.",
        "The start time of the break time cannot be earlier than the start work time.": "Fasilə vaxtının başlama vaxtı işə başlama vaxtından tez ola bilməz.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Etibarlı yoxlama vaxtının bitmə vaxtı işin bitmə vaxtından tez ola bilməz.",
        "The start time of the valid check time cannot be later than the start work time.": "Etibarlı yoxlama vaxtının başlama vaxtı işə başlama vaxtından gec ola bilməz.",
        "Deleting failed. The timetable is used by a shift.": "Silmək alınmadı. Cədvəl növbə ilə istifadə olunur.",
        "Deleting failed. The shift is in use.": "Silmək alınmadı. Növbə istifadə olunur.",
        "Deleting failed. The leave type is in use.": "Silmək alınmadı. Məzuniyyət növü istifadə olunur.",
        "Valid time conflicts with an existing schedule.": "Etibarlı vaxt mövcud cədvəllə ziddiyyət təşkil edir.",
        "The timing for multiple schedules must not coincide.": "Bir neçə cədvəlin vaxtı üst-üstə düşməməlidir.",
        "Attendance Log": "Davamiyyət Jurnalı",
        "Added Failed!": "Əlavə edilmədi!",
        "Setting WiFi": "WiFi qurulması",
        "License Plate": "Nömrə nişanı",
        "key": "Şifrə",
        "IQ Offline.": "IQ oflayn",
        "{0}Unlock": "{0} Kilidi açın",
        "automatically": "Avtomatik olaraq",
        "manually": "Manual",
        "Video Storage": "Video Saxlanması",
        "Device(s) for Video Storage": "Video yaddaşı üçün cihaz(lar)",
        "The amount of exported data is too large. Please export it in batches.": "İxrac olunan məlumatın miqdarı çox böyükdür. Zəhmət olmasa, məlumatı partiyalarla ixrac edin.",
        "Auto-record video when door unlocks": "Qapı açıldıqda avtomatik olaraq video yazılır",
        "Auto-record video during calls": "Zənglər zamanı avtomatik video yazısı",
        "Manual video recording in monitoring": "Monitorinqdə manual video yazılması",
        "Saved for 30days/60days/90days": "30gün/60gün/90gün üçün saxlanıldı",
        "To subscribe, please contact your provider for activation.": "Abunə olmaq üçün aktivləşdirmə üçün provayderinizlə əlaqə saxlayın.",
        "Saved for {0}days": "{0} gün üçün saxlanıldı",
        "Subscribed Plan": "Abunə olunan Plan",
        "Supported Devices: {0}": "Dəstəklənən cihazlar: {0}",
        "{0}Lock": "{0} Kilid",
        "Video Saving": "Video Yadda Saxlanılır",
        "Download Completed!": "Yükləmə tamamlandı!",
        "Fail to download.": "Yükləmək alınmadı.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Silinmə uğursuz oldu! Əmlak meneceri RentManager Müştərisinə bağlanıb, əvvəlcə onu silməlisiniz.",
        "No log to be exported.": "İxrac ediləcək heç bir qeyd yoxdur.",
        "capture&Video": "Çəkiliş & Video",
        "packageDetection": "Paket aşkarlanması",
        "Time format is invalid.": "Vaxt formatı yanlışdır.",
        "No permission to export logs of this type.": "Bu tip jurnalları ixrac etmək üçün icazə yoxdur.",
        "Project type is invalid.": "Proyekt növü yanlışdır.",
        "Salto Account Blocked.": "Salto Hesabı Bloklanıb.",
        "Remote open not in access group.": "Uzaqdan açmaq icazə qrupunda deyil.",
        "SIP Account required.": "SIP hesabı tələb olunur.",
        "The PIN must be {0} digits.": "PIN {0} rəqəmdən ibarət olmalıdır.",
        "gatewayConnectionUnavailable": "Gateway bağlantısı mövcud deyil.",
        "Invalid Username or Password": "Yanlış istifadəçi adı və ya şifrə",
        "Account already linked to another user.": "Hesab artıq başqa istifadəçi ilə əlaqələndirilib.",
        "The account has been added by another user.": "Hesab başqa istifadəçi tərəfindən əlavə edilib.",
        "Failed to add. This user already has 5 license plates.": "Əlavə etmək mümkün olmadı. Bu istifadəçinin artıq 5 dövlət nömrə nişanı var.",
        "Please at least select a door.": "Zəhmət olmasa, ən azı bir qapı seçin.",
        "UHF Card": "UHF Kart",
        "personnel": "personal",
        "Parking Lot Name": "Parkinq Sahəsinin Adı",
        "Controlled Relay": "İdarə olunan rele",
        "No Permission": "İcazə yoxdur",
        "Please ensure that all doors in the project are activated at the same time.": "Zəhmət olmasa, layihədəki bütün qapıların eyni anda aktivləşdirildiyinə əmin olun.",
        "gatewayBusy": "Gateway məşğuldur",
        "Please set the perimeter door group first.": "Zəhmət olmasa əvvəlcə perimetr qapı qrupunu təyin edin.",
        "Please ensure that all doors in the project are renewed at the same time.": "Zəhmət olmasa, layihədəki bütün qapıların eyni zamanda yenilənməsini təmin edin.",
        "When lockdown is on, the controlled relay cannot be modified.": "Kilidləmə aktiv olduqda, idarə olunan rele dəyişdirilə bilməz.",
        "DetectionLogs": "Aşkarlama qeydləri",
        "packageIn": "Paket daxil edildi",
        "packageOut": "Paket çıxarıldı",
        "View Progress": "Proqresi Görüntülə",
        "Check if the WiFi is operating on the 2.4GHz band.": "WiFi-nin 2.4GHz tezlik diapazonunda işlədiyini yoxlayın.",
        "Verify that the WiFi password is correct.": "WiFi parolunun düzgün olduğunu yoxlayın.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Hotspot konfiqurasiyası zamanı düzgün cihazın hotspotuna qoşulduğunuza əmin olun.",
        "Offline Code Unlock": "Offline Kodun Açılması",
        "Salto Token Expired.": "Salto Token-in müddəti bitib.",
        "Lock Offline": "Kilid oflayn",
        "identity information! Please login again": "şəxsiyyət məlumatları! Zəhmət olmasa yenidən daxil olun",
        "Email is required.": "Email tələb olunur.",
        "Mobile number is required.": "Mobil nömrə tələb olunur.",
        "You can\'t make payments for offices in different time zones.": "Fərqli saat qurşaqlarında olan ofislər üçün ödəniş edə bilməzsiniz.",
        "The current scheduling staff exceeds 200 people.": "Cari cədvəl üzrə işçi heyəti 200 nəfəri keçir.",
        "param": "parametr",
        "Invalid UserName or Password": "Yanlış istifadəçi adı və ya şifrə",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Sizin Salto KS hesabınız kilidin adını dəyişdirmək üçün icazəyə malik deyil.",
        "Owner is required.": "Sahib mütləqdir.",
        "Office is required.": "Ofis tələb olunur.",
        "PIN or RF Card is required.": "PIN və ya RF Kart tələb olunur.",
        "RF card": "RF kartı",
        "Personnel is required.": "Personal tələb olunur.",
        "email address": "e-poçt ünvanı",
        "mobile number": "mobil nömrə",
        "The length must be less than 32 characters.": "Uzunluq 32 simvoldan az olmalıdır.",
        "The length must be less than 256 characters.": "Uzunluq 256 simvoldan az olmalıdır.",
        "Access Group is required.": "Access Group tələb olunur.",
        "Device is required.": "Cihaz tələb olunur.",
        "Admin is required.": "Admin tələb olunur.",
        "Mobile number": "Mobil nömrə",
        "schedules": "cədvəllər",
        "Timetable name": "Cədvəl adı",
        "Shift name": "Növbənin adı",
        "Leave type": "Məzuniyyət növü",
        "recheck in time": "yenidən qeydiyyat vaxtı",
        "recheck out time": "yenidən çıxış vaxtı",
        "The building name": "Bina adı",
        "Building is required.": "Bina tələb olunur.",
        "Mac": "Mak",
        "selection, The same reader cannot be set for both entry and exit": "seçim, Eyni oxuyucu həm giriş, həm də çıxış üçün təyin edilə bilməz",
        "Door number": "Qapı nömrəsi",
        "door input cannot be selection duplicated.": "qapı girişi seçimi təkrarlana bilməz.",
        "Group is required.": "Qrup tələb olunur.",
        "Title can contain up to 32 characters.": "Başlıqda maksimum 32 simvol ola bilər.",
        "Content can contain up to 1024 characters.": "Məzmun maksimum 1024 simvola qədər ola bilər.",
        "Content can contain up to 64 characters.": "Məzmun maksimum 64 simvol ola bilər.",
        "Report is required.": "Hesabat tələb olunur.",
        "ID is required.": "İd tələb olunur.",
        "The office does not exist.": "Ofis mövcud deyil.",
        "Office name": "Ofis adı",
        "The Temp Key does not exist.": "Müvəqqəti açar mövcud deyil.",
        "autolock time": "avtomatik kilidləmə vaxtı",
        "The User does not exist.": "İstifadəçi mövcud deyil.",
        "The Installer does not exist.": "Quraşdırıcı mövcud deyil.",
        "The Project does not exist.": "Layihə mövcud deyil.",
        "The Distributor does not exist.": "Distribyutor mövcud deyil.",
        "The Community Device does not exist.": "Community Device mövcud deyil.",
        "The Property Manager does not exist.": "Əmlak İdarəçisi mövcud deyil.",
        "The Sub Distributor does not exist.": "Sub Distribyutor mövcud deyil.",
        "The Single Slave does not exist.": "Single Slave mövcud deyil.",
        "The Property Manager EndUser does not exist.": "Property Manager EndUser mövcud deyil.",
        "The Family Member does not exist.": "Ailə üzvü mövcud deyil.",
        "Set Failed!": "Quraşdırma uğursuz oldu!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Siz 30 dəqiqə ərzində 10 giriş kodu sorğusu limitinə çatmısınız. Zəhmət olmasa, bir az sonra yenidən cəhd edin.",
        "This Email doesn\'t exist.": "Bu Email mövcud deyil.",
        "detection type": "deteksiya növü",
        "Device UUID": "Cihaz UUID",
        "smart lock device": "ağıllı kilid cihazı",
        "You are trying too often, please try again in 5 minutes.": "Çox tez-tez cəhd edirsiniz, zəhmət olmasa 5 dəqiqədən sonra yenidən cəhd edin.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Eyni anda yalnız bir fayl idxal edə bilərsiniz. Zəhmət olmasa, cari idxalın bitməsini gözləyin.",
        "NVR Name": "NVR adı",
        "NVR Address": "NVR ünvanı",
        "Stay Alarm": "Alarmda qal",
        "Happended On": "Baş vermə tarixi",
        "Edit Milesight NVR": "Milesight NVR-ni redaktə et",
        "Add Milesight NVR": "Milesight NVR əlavə et",
        "Delete Device": "Cihazı Sil",
        "Auto-record video on motion detection, package detection": "Hərəkət aşkarlanması, bağlama aşkarlanması zamanı avtomatik video yazısı",
        "A 7-day free trial is included with your subscription.": "Abunəliyinizlə birlikdə 7 günlük pulsuz sınaq daxildir.",
        "For service renewal, please reach out to your provider.": "Xidmətin yenilənməsi üçün, zəhmət olmasa, təminatçınızla əlaqə saxlayın.",
        "Allow the Property Manager to view recorded videos": "Əmlak İdarəçisinə qeyd edilmiş videoları izləməyə icazə verin",
        "Please ensure the WiFi network is working properly.": "Zəhmət olmasa, WiFi şəbəkəsinin düzgün işlədiyinə əmin olun.",
        "Edit akubela Smart Locks": "Akubela Ağıllı Kilidləri redaktə et",
        "Upgraded Successfully!": "Uğurla yeniləndi!",
        "Upgraded Failed!": "Yeniləmə uğursuz oldu!",
        "Editing...": "Redaktə edilir...",
        "Edited successfully!": "Uğurla redaktə edildi!",
        "Edited Failed!": "Redaktə uğursuz oldu!",
        "Downloading video...": "Video yüklənir...",
        "All Locks": "Bütün Kilidlər",
        "Select Locks": "Kilidləri seçin",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "{0} rəqəmli PIN kodu akubela ağıllı kilidi şəbəkəyə qoşulduqdan sonra istifadə oluna bilər.\nZəhmət olmasa qeyd edin ki, PIN kodun təsirə başlaması üçün sinxronizasiya edildikdən sonra qısa bir vaxt lazım ola bilər.",
        "Please at least select a door or a lock.": "Zəhmət olmasa, ən azı bir qapı və ya bir kilid seçin.",
        "This lock has already been added to your apartment.": "Bu kilid artıq mənzilinizə əlavə edilib.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Bu kilid artıq başqa bir mənzilə əlavə edilib, xahiş edirik kömək üçün xidmət təminatçınızla əlaqə saxlayın.",
        "LockBody Version": "LockBody Versiyası",
        "Two-factor Authentication": "İki faktorlu autentifikasiya",
        "Monitoring Scope": "İzləmə Sahəsi",
        "Stay Duration": "Qalma Müddəti",
        "Volume Settings": "Səs Ayarları",
        "get card list for lock error": "kilid kart siyahısını əldə etmək xətası",
        "get card list parse fail": "kart siyahısının alınması və təhlili uğursuz oldu",
        "get pin list for lock error": "kilid üçün pin siyahısını əldə etmə xətası",
        "get pin list parse fail": "pin siyahısını əldə etməyi parse etmək alınmadı",
        "fingerprint code must be less than 2048 characters or empty.": "barmaq izi kodu 2048 simvoldan az olmalı və ya boş olmalıdır.",
        "Personnel not in office.": "Şəxslər ofisdə deyil.",
        "customize form fail.": "formanı fərdiləşdirmək alınmadı.",
        "smart lock type error.": "ağıllı kilid növü xətası.",
        "invalid client id or secret": "etibarsız müştəri id-si və ya gizli açar",
        "invalid account or password": "etibarsız hesab və ya şifrə",
        "invalid access token": "etibarsız giriş nişanı",
        "invalid refresh token": "etibarsız yeniləmə nişanı",
        "no permission to access this project": "bu layihəyə daxil olmaq üçün icazəniz yoxdur",
        "Stay Alarm Time": "Alarm vaxtını saxla",
        "This function only support sl20 lock.": "Bu funksiya yalnız sl20 kilidini dəstəkləyir.",
        "Json marshal error.": "Json marshal xətası.",
        "Json unmarshal error.": "Json unmarshal xətası.",
        "Illegal request, not added within valid time.": "Qeyri-qanuni sorğu, etibarlı vaxt ərzində əlavə edilməyib.",
        "invalid nvr type": "etibarsız nvr tipi",
        "project is empty": "proyekt boşdur",
        "project type is invalid": "proyekt növü yanlışdır",
        "owner is invalid": "sahibkar etibarsızdır",
        "url is invalid": "url etibarsızdır",
        "password is invalid": "şifrə yanlışdır",
        "building is invalid": "bina etibarsızdır",
        "fail to get data": "məlumat əldə etmək mümkün olmadı",
        "invalid allow pm view type": "etibarsız icazə verilən pm baxış növü",
        "Data not exist.": "Məlumat mövcud deyil.",
        "cannot find community PrivateKey.": "community PrivateKey tapılmadı.",
        "cannot find single PrivateKey.": "tək bir PrivateKey tapılmadı.",
        "The third party not exist.": "Üçüncü tərəf mövcud deyil.",
        "{0} and indoor monitors/guard phones": "{0} və daxili monitorlar/mühafizə telefonları",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} və daxili monitorlar/idarəçi telefonları, ehtiyat olaraq telefon nömrəsi ilə",
        "Indoor monitors/guard phones with {0} as backup": "{0} ehtiyat nüsxəsi kimi olan daxili monitorlar/mühafizə telefonları",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Əvvəlcə daxili monitorlar/mühafizə telefonları, ehtiyat olaraq {0}, sonda isə telefon nömrəsi çağırılır.",
        "{0} Intercom Feature": "{0} İnterkom Funksiyası",
        "Capture on {0}": "{0} tətbiqində ekran görüntüsü",
        "{0} Intercom Feature is not activated or has expired.": "{0} Interkom funksiyası aktiv edilməyib və ya müddəti bitib.",
        "fingerprint code must be equal 1620 characters or empty.": "barmaq izi kodu 1620 simvola bərabər olmalı və ya boş olmalıdır.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Uğurlu yeniləmə üçün, xahiş edirik davam etməzdən əvvəl kilidin batareya səviyyəsinin 40%-dən yuxarı olduğuna əmin olun.",
        "Automatic Locking Time": "Avtomatik kilidləmə vaxtı",
        "WiFi Keep-Alive": "WiFi Aktiv Saxlama",
        "WiFi Setting": "WiFi Ayarları",
        "Connecting the network...": "Şəbəkəyə qoşulur...",
        "Set successfully!": "Uğurla təyin edildi!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Offline kodu, kilid WiFi-ə qoşulmadıqda belə istifadə oluna bilər.",
        "Enabling this feature will increase the lock\'s power consumption.": "Bu funksiyanı aktivləşdirmək kilidin enerji sərfiyyatını artıracaq.",
        "Each offline code can only be used once.": "Hər bir oflayn kod yalnız bir dəfə istifadə oluna bilər.",
        "Receiver Info": "Qəbul Edənin Məlumatı",
        "log id": "giriş id-si",
        "Create HW SN Config Empty SN.": "HW SN Konfiqurasiyasını Yarat Boş SN.",
        "The SN": "SN",
        "SN can contain up to 32 characters.": "SN ən çox 32 simvoldan ibarət ola bilər.",
        "Check HW SN Not Found.": "HW SN Tapılmadı Yoxlayın.",
        "the end user not found": "son istifadəçi tapılmadı",
        "Family Call": "Ailə Zəngi",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Yeniləmə zamanı bütün kilidlə bağlı funksiyalar müvəqqəti olaraq əlçatmaz olacaq.",
        "8-digit PIN code starting with \"9\" is invalid!": "\"9\" ilə başlayan 8 rəqəmli PIN kodu etibarsızdır!",
        "Lock name length must be between 1 and 50": "Kilidin adı uzunluğu 1 ilə 50 arasında olmalıdır",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Sabit telefon xidməti olan işçilərin sayı {0} Interkom xidməti olanların sayını keçə bilməz.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Sabit telefon xidməti olan adminlərin sayı {0} Interkom xidməti olanların sayını keçə bilməz.",
        "charge type": "ödəniş növü",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Sabit telefon xidməti olan işçilərin sayı SmartPlus Intercom istifadə edənlərin sayını keçə bilməz.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Sabit telefon xidməti olan adminlərin sayı SmartPlus Intercom xidməti olanların sayını keçə bilməz.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Oxucu eyni anda həm Wiegand, həm də RS485 istifadə etmək üçün konfiqurasiya oluna bilməz.",
        "parameter error": "parametr xətası",
        "community name already exist": "icma adı artıq mövcuddur",
        "personnel app without intercom feature number": "interkom funksiyası olmayan nömrəli personal tətbiqi",
        "check feature billing charge plan new error": "xüsusiyyətin ödəniş planını yoxla yeni səhv",
        "subscription not found": "abunə tapılmadı",
        "System setting record not found.": "Sistem ayarları qeydi tapılmadı.",
        "Smart home not enabled.": "Ağıllı ev aktiv deyil.",
        "the apt call type value is invalid.": "apt çağırış növü dəyəri yanlışdır.",
        "the ip call or sip call value is invalid.": "ip zəngi və ya sip zəngi dəyəri etibarsızdır.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode 2-8 rəqəmli olmalıdır, lakin 9 ilə başlayan 8 rəqəmli və ya boş ola bilməz.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard A-F0-9 olmalı və 16 bitdən az və ya boş olmalıdır.",
        "owner cannot be empty.": "sahib boş ola bilməz.",
        "creator cannot be empty.": "yaradıcı boş ola bilməz.",
        "the creator type value is invalid": "yaradıcının növü dəyəri yanlışdır",
        "the IsCreateByPm value is invalid": "IsCreateByPm dəyəri yanlışdır",
        "the pinCode already exist": "pinCode artıq mövcuddur",
        "the rfCard already exist": "rfCard artıq mövcuddur",
        "license plate is invalid.": "nömrə nişanı etibarsızdır.",
        "owner info is invalid.": "sahib məlumatı yanlışdır.",
        "uhf is invalid.": "uhf etibarsızdır.",
        "time control is invalid.": "vaxt nəzarəti etibarsızdır.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Siz 5 Avtomobil Nömrə Nişanı limitinə çatmısınız və əlavə etməyə icazə verilmir.",
        "the plate already exist": "nömrə artıq mövcuddur",
        "the uhf already exist": "uhf artıq mövcuddur",
        "empty community": "boş icma",
        "no find license Plate": "nömrə nişanı tapılmadı",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess rejimi 0, 1 və ya 2 olmalıdır.",
        "Run field is required when mode is 1 or 2.": "Run sahəsi, rejim 1 və ya 2 olduqda tələb olunur.",
        "Serial field is required when mode is 2.": "Serial sahəsi rejim 2 olduqda tələb olunur.",
        "the pin cannot be empty": "pin boş ola bilməz",
        "the rfCard cannot be empty": "rfCard boş ola bilməz",
        "the IDAccess already exist": "IDAccess artıq mövcuddur",
        "the resident cannot be empty": "rezident boş ola bilməz",
        "the fingerprint cannot be empty": "barmaq izi boş ola bilməz",
        "the face cannot be empty": "üz boş ola bilməz",
        "not found pin": "pin tapılmadı",
        "not found rfCard": "rfCard tapılmadı",
        "not found IDAccess": "tapılmadı IDAccess",
        "not found fingerprint": "barmaq izi tapılmadı",
        "not found face": "üz tapılmadı",
        "face pic is invalid.": "üz şəkli etibarsızdır.",
        "community build and room cannot be empty.": "icma quruculuğu və otaq boş ola bilməz.",
        "device info mac cannot be empty.": "cihaz məlumatı mac boş ola bilməz.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "planlaşdırıcı növü 0,1,2 olmalıdır və ya vaxt formatı yanlışdır və ya dataflag 0-127 aralığında deyil.",
        "MAC address cannot be empty.": "MAC ünvanı boş ola bilməz.",
        "MAC address 0C1105000000 is not allowed.": "MAC ünvanı 0C1105000000 icazə verilmir.",
        "MAC address must be 12 hexadecimal characters.": "MAC ünvanı 12 onaltılı simvoldan ibarət olmalıdır.",
        "Scheduler type value is invalid.": "Planlaşdırıcı növünün dəyəri yanlışdır.",
        "parse is fail": "parse uğursuz oldu",
        "the fingerprint already exist": "barmaq izi artıq mövcuddur",
        "the licensePlate cannot be empty": "licensePlate boş ola bilməz",
        "the licensePlate already exist": "nömrə nişanı artıq mövcuddur",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run 10 rəqəmli ədəd olmalı və ya -K ilə bitməlidir.",
        "idaccess serial must be 9 digit number.": "idaccess seriya nömrəsi 9 rəqəmli olmalıdır.",
        "relay not in 0-15": "rele 0-15 aralığında deyil",
        "security relay not in 0-3": "təhlükəsizlik releysi 0-3 aralığında deyil",
        "file name is wrong": "fayl adı yanlışdır",
        "access mode specified": "giriş rejimi göstərildi",
        "create community user accessmode failed.": "icma icma istifadəçi giriş rejiminin yaradılması alınmadı.",
        "delete community user accessmode failed.": "icmanın istifadəçisinin giriş rejimini silmək alınmadı.",
        "Cannot delete building because it has associated users.": "Binanı silmək mümkün deyil, çünki onunla əlaqəli istifadəçilər var.",
        "Cannot delete building because it has associated Salto devices.": "Binanı silmək mümkün deyil, çünki onunla əlaqəli Salto cihazları var.",
        "community building not found": "icma binası tapılmadı",
        "Invalid Name Display": "Yanlış Ad Göstərimi",
        "The Community does not exist.": "İcma mövcud deyil.",
        "Update CommunityIsInstallerKit Error.": "CommunityIsInstallerKit səhvini yeniləyin.",
        "Dis Not SupportCommunityCalls Error.": "Dis Not SupportCommunityCalls Xətası.",
        "Community Has Special Device, Not Allowed To Delete.": "İcmanın xüsusi cihazı var, silinməsinə icazə verilmir.",
        "The project smart home switch must be disabled": "Proyekt ağıllı ev açarı mütləq deaktiv edilməlidir",
        "There are ITec Locks in project": "Proyektdə ITec kilidləri var",
        "There are Salto Locks in project": "Proyektdə Salto kilidləri var",
        "There are Dormakaba Locks in project": "Proyektdə Dormakaba kilidləri var",
        "It is rent manager project": "Bu, rent manager layihəsidir",
        "It is installer account": "Bu quraşdırıcı hesabıdır",
        "contact preference type": "əlaqə üstünlüyü növü",
        "Floor list is required when not all floors.": "Bütün mərtəbələr olmadıqda mərtəbə siyahısı tələb olunur.",
        "Building floors list is required when all buildings.": "Bütün binalar üçün bina mərtəbələri siyahısı tələb olunur.",
        "Indoor monitor name is required.": "Daxili monitorun adı tələb olunur.",
        "The primary account is not activated.": "Əsas hesab aktivləşdirilməyib.",
        "You can\'t create more family member accounts.": "Daha çox ailə üzvü hesabı yarada bilməzsiniz.",
        "community user not found": "icma istifadəçisi tapılmadı",
        "community is empty": "icma boşdur",
        "the end user not master user": "son istifadəçi əsas istifadəçi deyil",
        "the end user not member user": "son istifadəçi üzv istifadəçi deyil",
        "The email already exists and cannot be repeated": "E-poçt artıq mövcuddur və təkrar edilə bilməz",
        "The mobile Number already exists": "Mobil nömrə artıq mövcuddur",
        "The room number format error.": "Ota nömrəsinin formatı səhvdir.",
        "community not found": "icma tapılmadı",
        "resident not found": "rezident tapılmadı",
        "installer not found": "quraşdırıcı tapılmadı",
        "Operation Failed!": "Əməliyyat uğursuz oldu!",
        "You don\'t have operate permission": "Sizin əməliyyat icazəniz yoxdur",
        "You cannot select Relay and Door at the same time": "Siz eyni zamanda Relay və Door seçə bilməzsiniz",
        "user don\'t active": "istifadəçi aktiv deyil",
        "User has expired": "İstifadəçi müddəti bitib",
        "timestamp must be within 3 minutes of current server time": "timestamp cari server vaxtından 3 dəqiqə daxilində olmalıdır",
        "cannot find single rf Card.": "tək bir rf Card tapılmadı.",
        "cannot find community rf Card.": "icmaiyyətin rf Kartını tapmaq mümkün deyil.",
        "smartLock model": "smartLock modeli",
        "the project does not open smart home": "proyekt ağıllı evi açmır",
        "php web server error": "php veb server xətası",
        "Ins not found.": "Ins tapılmadı.",
        "RentManage Unit Not Set.": "RentManage vahidi təyin edilməyib.",
        "add audit log error": "audit qeydlərinin əlavə edilməsi xətası",
        "check building in error": "səhv binanı yoxla",
        "Special devices cannot be deleted": "Xüsusi cihazları silmək mümkün deyil",
        "the email is empty": "e-poçt boşdur",
        "the email format is incorrect": "email formatı yanlışdır",
        "the mobile number is empty": "mobil nömrə boşdur",
        "the mobile number format is incorrect": "mobil nömrə formatı yanlışdır",
        "Site not found": "Sayt tapılmadı",
        "User not found": "İstifadəçi tapılmadı",
        "invalid time format": "yanlış vaxt formatı",
        "ground floor type": "yerüstü mərtəbə növü",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Başlama mərtəbə aralığı xətası, düzgün dəyərlər -10-dan -1-ə, G0, G1, G2, 1-dən 128-ə qədərdir.",
        "Building ID must be between 1 and 99.": "Bina ID-si 1 ilə 99 arasında olmalıdır.",
        "Community building name": "İcma binasının adı",
        "Building ID already exists in this community.": "Bu icmada bu bina ID-si artıq mövcuddur.",
        "building ID": "bina ID-si",
        "Community building not found.": "İcma binası tapılmadı.",
        "Cannot delete building because it has associated devices.": "Binanı silmək mümkün deyil, çünki onunla əlaqəli cihazlar var.",
        "project is not valid": "proyekt etibarlı deyil",
        "Cannot delete building because it has associated salto devices.": "Binanı silmək mümkün deyil, çünki onunla əlaqəli salto cihazları var.",
        "Cannot delete building because it has associated iTec devices.": "Binanı silmək mümkün deyil, çünki onunla əlaqəli iTec cihazları var.",
        "Cannot delete building because it has associated dormakaba devices.": "Binanı silmək mümkün deyil, çünki onunla əlaqəli dormakaba cihazları var.",
        "member limit num": "üzv limit sayı",
        "Indoor Monitor No Set Error.": "Daxili Monitor Quraşdırılmayıb Xətası.",
        "The room not has indoor": "Otaqda daxili yoxdur",
        "check user in building error": "istifadəçini binada yoxla xətası",
        "The name specified is already in use.": "Göstərilən ad artıq istifadə olunur.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Bu zaman aralığı mövcud olanla üst-üstə düşür. Zəhmət olmasa, düzəliş edin.",
        "This door status changed. Please try again.": "Bu qapının statusu dəyişdi. Zəhmət olmasa, yenidən cəhd edin.",
        "the lock can\'t bind this community": "kilid bu icmanı bağlaya bilmir",
        "The custom quantity limit has been exceeded!": "Fərdi miqdar limiti aşılıb!",
        "This time span overlaps with an existing one. Please adjust it.": "Bu zaman aralığı mövcud olanla üst-üstə düşür. Zəhmət olmasa, onu tənzimləyin.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Bu bir dəfəlik cədvəlin vaxtı mövcud bir dəfəlik cədvəlin effektiv vaxtı ilə üst-üstə düşür. Zəhmət olmasa, düzəliş edin.",
        "Operation Failed. Please try again.": "Əməliyyat uğursuz oldu. Zəhmət olmasa, yenidən cəhd edin.",
        "The image is not a front view.": "Şəkil ön görünüş deyil.",
        "A mask was detected.": "Maska aşkarlandı.",
        "The image resolution is too low.": "Şəklin çözünürlüğü çox aşağıdır.",
        "No face was detected.": "Heç bir üz aşkar edilmədi.",
        "The file size is too large.": "Faylın ölçüsü çox böyükdür.",
        "The face in the image is too large.": "Şəkildəki üz çox böyükdür.",
        "The face in the image is too small.": "Şəkildəki üz çox kiçikdir.",
        "Multiple faces detected.": "Bir neçə üz aşkarlandı.",
        "The face is not clear enough.": "Üz kifayət qədər aydın deyil.",
        "Face detection failed.": "Üz tanıma alınmadı.",
        "Please enter a value between 1 and 9999": "Zəhmət olmasa, 1 ilə 9999 arasında bir dəyər daxil edin",
        "Please select which input your door sensor is connected to.": "Zəhmət olmasa, qapı sensorunuzun hansı girişə qoşulduğunu seçin.",
        "Add temp key failed, please try it again": "Müvəqqəti açarın əlavə edilməsi alınmadı, zəhmət olmasa yenidən cəhd edin",
        "Dis Not Support Dynamic QRCode Error.": "Dinamik QR Kodunu Dəstəkləmir Xətası.",
        "QR code not exist": "QR kod mövcud deyil",
        "The temp key has expired.": "Müvəqqəti açarın müddəti bitib.",
        "The device is not in the office": "Cihaz ofisdə deyil",
        "The device is already assigned.": "Cihaz artıq təyin edilib.",
        "The device cannot be assigned to any user.": "Cihaz heç bir istifadəçiyə təyin edilə bilməz.",
        "You cannot select an option with fewer users than the current project members.": "Cari layihə üzvlərindən daha az istifadəçi olan bir seçimi seçə bilməzsiniz.",
        "File check failed. Please download the latest template and try again.": "Fayl yoxlanışı uğursuz oldu. Zəhmət olmasa, ən son şablonu yükləyin və yenidən cəhd edin.",
        "Dynamic QR Code not active.": "Dinamik QR kod aktiv deyil.",
        "Dynamic QR Code not enable.": "Dinamik QR kod aktiv deyil.",
        "{0} not found.": "{0} tapılmadı.",
        "Tier charge plan": "Pilləli ödəniş planı",
        "Feature billing charge plan new": "Xüsusiyyət üzrə ödəniş planı yeni",
        "Feature billing gradient charge plan": "Xüsusiyyət üzrə ödənişin gradiasiya olunmuş tarif planı",
        "The exit time cannot be earlier than the entry time.": "Çıxış vaxtı giriş vaxtından daha əvvəl ola bilməz.",
        "User Name or Password": "İstifadəçi adı və ya parol",
        "You can only link up to 5 sites.": "Siz ən çox 5 obyekti əlaqələndirə bilərsiniz.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Bu dövlət nömrə nişanı artıq bir sakinin adına qeydiyyata alınıb və qara siyahıya əlavə edilə bilməz.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Bu dövlət nömrə nişanı qara siyahıya salınıb və nəqliyyat vasitəsi kimi qeydiyyata alına bilməz.",
        "Elevator not configured in company access floor.": "Lift şirkətin keçid mərtəbələrində konfiqurasiya edilməyib.",
        "the device is not in the office": "Cihaz ofisdə deyil",
        "A maximum of 1000 data items can be imported": "Ən çox 1000 məlumat elementi idxal edilə bilər",
        "Exit time cannot be later than the current time.": "Çıxış vaxtı cari vaxtdan gec ola bilməz.",
        "You can only import a file at a time in the current parking lot.": "Hazırkı avtodayanacaqda hər dəfə yalnız bir fayl idxal edə bilərsiniz.",
        "The license plate is already in the blocklist.": "Dövlət nömrə nişanı artıq qara siyahıdadır.",
        "Building name too long.": "Bina adı həddən artıq uzundur.",
        "Unlock failed. Permission denied by user.": "Qapı açılmadı. İstifadəçi icazəni rədd etdi.",
        "Please remove the sensor device(s) before disabling this feature.": "Bu funksiyanı deaktiv etməzdən əvvəl sensor cihaz(lar)ını çıxarın.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Əməliyyat uğursuz oldu! Bu istifadəçi üçün gündəlik 15 qeyd limiti aşılıb.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Hər layihəyə maksimum {0} ictimai cihaz əlavə edilə bilər. Daha çox əlavə etmək üçün support{'@'}akuvox.com ünvanı ilə Akuvox Texniki Dəstəyi ilə əlaqə saxlayın.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Hər layihəyə maksimum {0} əməkdaş hesabı əlavə edilə bilər. Daha çox əlavə etmək üçün support{'@'}akuvox.com ünvanı ilə Akuvox Texniki Dəstəyi ilə əlaqə saxlayın.",
        "cancel": "Ləğv",
        "bluetooth": "Bluetooth",


    }
};
